import { PollForm } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/Compass/PollForm";
import { usePollForm } from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/Compass/usePollForm";
import {
  POLL_FORM_ID,
  type EditPollModalProps,
} from "@circle-react-shared/uikit/TipTapBlockEditor/PollExtension/PollModal/types";
import { Modal } from "@circleco/compass/components/Modal";
import { useToast } from "@circleco/compass/context/CompassContext";
import { useRef } from "react";
import { useQueryClient } from "react-query";

import { t } from "@/i18n-js/instance";
import type { CompassModalProps } from "@/react/components/SettingsApp/CompassCompat/modalHelpers";

export const EditPollModalComponent = ({
  pollSgid,
  open,
  onOpenChange,
}: EditPollModalProps & CompassModalProps) => {
  const initialFocusRef = useRef<HTMLInputElement>(null);
  const queryClient = useQueryClient();
  const toast = useToast();

  const {
    canEditOptions,
    isLoadingPollForEdit,
    isSubmitting,
    isValid,
    methods,
    onSubmit,
  } = usePollForm({
    isEdit: true,
    pollSgid,
    onComplete: () => {
      toast.add({
        title: t("tiptap.extensions.poll.edit_success"),
        variant: "primary",
        icon: "circle-check-filled",
        iconColor: "success",
      });
      queryClient.removeQueries({ queryKey: ["poll", pollSgid] });
    },
  });

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="md">
      <Modal.Content>
        <Modal.Header title={t("tiptap.extensions.poll.edit")} />
        <Modal.Body>
          <PollForm
            canEditOptions={canEditOptions}
            initialFocusRef={initialFocusRef}
            isLoading={isLoadingPollForEdit}
            methods={methods}
            onSubmit={onSubmit}
          />
        </Modal.Body>
        <Modal.Footer
          primaryAction={{
            type: "submit",
            form: POLL_FORM_ID,
            label: t("tiptap.extensions.poll.save"),
            loading: isSubmitting,
            disabled: isSubmitting || isLoadingPollForEdit || !isValid,
          }}
          secondaryAction={{
            label: t("tiptap.extensions.poll.cancel"),
            onClick: () => onOpenChange(false),
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};
